import { db } from '../firebase';
import { collection, doc, setDoc, serverTimestamp } from 'firebase/firestore';

/**
 * Helper function to create an in-app notification.
 * @param {Object} params
 * @param {string} params.userId - ID of the user receiving the notification
 * @param {string} params.type - Type of notification (ad_posted, ad_sold, ad_deleted, ad_boosted, etc.)
 * @param {string} params.title - Title of the notification
 * @param {string} params.message - Body message
 * @param {string} [params.adId] - Optional ad ID associated with the notification
 * @param {string} [params.adTitle] - Optional ad title
 * @param {Object} [params.transaction] - Optional Firestore transaction to run the write inside
 */
export const createNotification = async ({ userId, type, title, message, adId = null, adTitle = null, transaction = null }) => {
  if (!userId) return;

  const notifRef = doc(collection(db, 'notifications'));
  
  const payload = {
    userId,
    type,
    title,
    message,
    adId,
    adTitle,
    read: false,
    createdAt: serverTimestamp()
  };

  if (transaction) {
    transaction.set(notifRef, payload);
  } else {
    await setDoc(notifRef, payload);
  }
};
